import { render, staticRenderFns } from "./popup-processor.vue?vue&type=template&id=2ce6f594&scoped=true"
import script from "./popup-processor.vue?vue&type=script&lang=js"
export * from "./popup-processor.vue?vue&type=script&lang=js"
import style0 from "./popup-processor.vue?vue&type=style&index=0&id=2ce6f594&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce6f594",
  null
  
)

export default component.exports